import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { persistentKeyboardDismiss } from "@-/dev.improve.haniverse.components.collapsible-persistent-keyboard";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { DrillPageContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";
import { useCallback } from "react";

export function useDrillPageAnswerMode() {
  const { reviewMode } = useActorUser();
  const [isAnswerBarHidden] = useDeviceSetting("isAnswerBarHidden");
  const [setIsAnswerModeOpen] = useContextSelectors(DrillPageContext, (c) => c.setIsAnswerModeOpen);
  const isAnswerModeActive = reviewMode === "answer" && !isAnswerBarHidden;
  const isTapToRevealPromptVisible = !isAnswerModeActive;

  const openAnswerMode = useCallback(() => {
    setIsAnswerModeOpen(true);
  }, [setIsAnswerModeOpen]);

  const closeAnswerMode = useCallback(() => {
    persistentKeyboardDismiss();
    setIsAnswerModeOpen(false);
  }, [setIsAnswerModeOpen]);

  return {
    closeAnswerMode,
    isAnswerBarHidden,
    isAnswerModeActive,
    isTapToRevealPromptVisible,
    openAnswerMode,
    reviewMode,
  };
}
